import { createContext } from 'react';
import { useSelector } from 'react-redux';

const AuthContext = createContext(null);

export function AuthContextProvider({children}) {

  const profile_reducer = useSelector((state) => { return state.profileReducer })
  

  console.log('AuthContextProvider')

  return (
    <AuthContext.Provider value={profile_reducer}>
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
